<script setup>
import { defineProps, defineEmits} from "vue";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "dado",
    "controlesDesativados"
]);

const emits = defineEmits([
    "update:alteraDado",
]);

//==================================================================//
//========================= Altera Dado ============================//
//==================================================================//

const alteraDado = (update) => {

    emits('update:alteraDado',update);

};

//==================================================================//
//============ Ao Preencher Lista de Referencia ====================//
//==================================================================//

const aoPreencherJustificativaDeCancelamento = (justificativaDeCancelamento) => {

    alteraDado({
        justificativaDeCancelamento: justificativaDeCancelamento
    });
    
};

</script>

<template>

    <v-card class="c-cartao">

        <v-card-title class="c-cartao__titulo">

            <h3 class="c-titulo">

                Justificativa de Cancelamento

            </h3>

        </v-card-title>

        <div class="c-cartao__conteudo">

            <div class="c-campo">

                <v-textarea
                    :value="props?.dado?.justificativaDeCancelamento"
                    :disabled="props?.controlesDesativados"
                    label="Justificativa de Cancelamento"
                    variant="outlined"
                    no-resize
                    outlined
                    auto-grow
                    @input="aoPreencherJustificativaDeCancelamento"
                ></v-textarea>

            </div>

        </div>

    </v-card>

</template>

<style scoped>

.c-cartao__titulo{
    display: grid; 
    grid-template-columns: 1fr; 
    grid-template-rows: 1fr; 
    gap: 10px; 
    grid-template-areas: 
        "titulo";
}

.c-titulo {
    grid-area: titulo;
}

</style>